type Props = { name: string; src?: string | null; size?: number };

export default function UserAvatar({ name, src, size = 28 }: Props) {
  const initials = (name || "U").trim().slice(0, 1).toUpperCase();
  const s = `${size}px`;
  if (src) {
    return (
      <img
        src={src}
        alt="avatar"
        width={size}
        height={size}
        className="rounded-full object-cover"
        referrerPolicy="no-referrer"
        style={{ width: s, height: s }}
      />
    );
  }
  return (
    <div
      className="rounded-full bg-indigo-500 grid place-items-center text-white font-bold"
      style={{ width: s, height: s }}
    >
      {initials}
    </div>
  );
}
